import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DeviceService } from '../../services/device-service/device.service';
import { AllCommunityModule, ClientSideRowModelModule, ColDef, GridApi, GridOptions, GridReadyEvent, ModuleRegistry, PaginationChangedEvent, provideGlobalGridOptions, RowNode, RowSelectionOptions } from 'ag-grid-community';
import { AgGridAngular } from 'ag-grid-angular';
import { AgGridModule } from 'ag-grid-angular';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import moment from 'moment';

@Component({
  selector: 'app-config-history-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    AgGridAngular,
    MatIconModule,
    MatButtonModule,
    AgGridModule,
    CommonModule,
  ],
  templateUrl: './config-history-dialog.component.html',
  styleUrl: './config-history-dialog.component.scss'
})
export class ConfigHistoryDialogComponent {
  customerName: string;
  groupName: string;
  cpId: number;
  gpId: number;
  constructor(
    public dialogRef: MatDialogRef<ConfigHistoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public deviceService: DeviceService,
  ) {
    this.customerName = data.customerName;
    this.groupName = data.groupName;
    this.cpId = data.cpId;
    this.gpId = data.gpId;
  }

  rowData: any[] = [];
  total_number_of_records = 0;
  defaultColDef = { flex: 1, resizable: true };
  columnDefs = [
    { headerName: 'Config Version', field: 'configVersion', sortable: false },
    {
      headerName: 'Upload Time (UTC)',
      field: 'dateTime',
      sortable: false,
      cellRenderer: (params: any) => {
        if (params?.data?.dateTime === undefined) {
          return '';
        } else if (
          params?.data?.dateTime === null ||
          params?.data?.dateTime === ''
        ) {
          return 'N/A';
        } else {
          return moment.utc(params?.data?.dateTime).format('YYYY-MM-DD HH:mm:ss')
        }
      }
    },
  ];

  ngOnInit(): void {
    const cpId = this.data.cpId;
    const gpId = this.data.gpId;

    this.customerName = this.data.customerName;
    this.groupName = this.data.groupName;

    this.deviceService.getConfigHistoryList(cpId, gpId).subscribe((res) => {
      this.rowData = res?.data?.content || [];
      console.log(this.rowData);
    });
  }

  onClose() {
    this.dialogRef.close();
  }
}
